export enum Pathnames {
  HOME = "/",
  FAVORITES = "/favorites",
}
